import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { PrePopulatedTooltip } from 'components/Offers/fragments/PrePopulatedTooltip/PrePopulatedTooltip';

export const CreditCardPreApprovedMessage = props => {
  const { prePopulatedTooltipText, className, tooltipWhite } = props;

  return (
    <>
      <FlexContainer className={className}>
        <PrePopulatedTooltip
          prePopulatedTooltipText={prePopulatedTooltipText}
          tooltipWhite={tooltipWhite}
        />
      </FlexContainer>
    </>
  );
};
